import { Theme, makeStyles, createStyles, Hidden } from '@material-ui/core';
import React, { FC } from 'react';
import { FormControlProps } from '..';
import { TableDefinition } from '../services';
import { registry } from '../registry';
import { LayoutNodeWrapper } from './LayoutNode';
import { TableRow } from './TableRow';

export interface TableProps extends FormControlProps<TableDefinition> {
}

const useStyles = makeStyles(function(theme: Theme) {
  return createStyles({
    root: {
      flex: 1,
      marginBottom: theme.spacing(1),
      display: 'flex'
    },
    table(props: TableProps) {
      const styles: {[key: string]: any} = {
        flex: 1,
        'border-collapse': 'collapse',
        'table-layout': 'fixed',
        border: '1px solid #bdbdbd8c'
      }

      return styles;
    },
    header(props: TableProps) {
      let styles: {} = {
        alignContent: 'center',
        marginBottom: theme.spacing(1),
        background: '#28316f',
        color: 'white'
      }
      if (props.definition.style?.stickyHeader) {
        styles = {
          ...styles,
          [theme.breakpoints.up('md')]: {
            position: 'sticky',
            top: '0px',
            zIndex: 999
          },
        }
      }
      return styles;
    },
    headerRow: {

    },
    headerCell(props: TableProps) {
      const styles: {[key: string]: any} = {
        padding: '6px'
      };

      styles[theme.breakpoints.up('md')] = {
        '&:first-child': {
          width: '33%'
        }
      }
      
      return styles;
    }
  })
});

export const Table: FC<TableProps> = function(props) {
  const { definition, path } = props;
  const classes = useStyles(props);
  const styles = definition?.style ?? {};

  return (
    <React.Fragment>
      <Hidden mdUp>
        <div className = { classes.root } style = {styles}>
          <table className = { classes.table }>
            { definition.header ? (
              <thead className = { classes.header }>
                <tr className = { classes.headerRow }>
                  {
                    definition.header.children.slice(1).map((cell, cellIndex) => {
                      return <th className = { classes.headerCell } key = { cellIndex + 1 } colSpan={cell.colSpan ?? 1}>
                        <LayoutNodeWrapper
                          path = { `${path.concat('/header/children/')}${+cellIndex + 1}/content` }>
                        </LayoutNodeWrapper>
                      </th>
                    })
                  }
                </tr>
              </thead>
            ) : null
            }
            <tbody>
              {
                definition.rows.map((row, rowIndex) => {
                  return <TableRow rowIndex={ rowIndex } key={rowIndex} path={path.concat('/rows/') + rowIndex } definition={row} header={definition.header} tableDefinition={definition}></TableRow>
                })
              }
            </tbody>
          </table>
        </div>
      </Hidden>
      <Hidden smDown>
        <div className = { classes.root } style = {styles}>
          <table className = { classes.table }>
            { definition.header ? (
              <thead className = { classes.header }>
                <tr className = { classes.headerRow }>
                  {
                    definition.header.children.map((cell, cellIndex) => {
                      return <th className = { classes.headerCell } key = { cellIndex } colSpan={cell.colSpan ?? 1}>
                        <LayoutNodeWrapper
                          path = { path.concat('/header/children/') + cellIndex + '/content' }>
                        </LayoutNodeWrapper>
                      </th>
                    })
                  }
                </tr>
              </thead>
            ) : null
            }
            <tbody>
              {
                definition.rows.map((row, rowIndex) => {
                  return <TableRow rowIndex={ rowIndex } key={rowIndex} path={path.concat('/rows/') + rowIndex } definition={row} header={definition.header} tableDefinition={definition}></TableRow>
                })
              }
            </tbody>
          </table>
        </div>
      </Hidden>
    </React.Fragment>
  )
};

registry.registerComponent('Table', Table);
